import _ from 'lodash'
import { fromClassicCss } from '../../utils/fromClassicCss'
import type { DomApplier } from '../cssFeatures.types'
import { SelectorObj } from '../../shared.types'

export const compsMeasuresCssDomApplier: DomApplier<'compsMeasuresCss'> = (
	__,
	idSelector,
	_breakpointId,
	{ compsMeasures, autoHeightWrapper }
) => {
	if (!compsMeasures) {
		return null
	}

	const acc: SelectorObj = fromClassicCss(compsMeasures.css, idSelector, autoHeightWrapper ? 'wrapper-' : '')

	// Adding auto height wrapper in case we don't have a placeholder
	if (autoHeightWrapper) {
		const res = _.mapValues(acc, (value) => {
			const compHeight = value.height
			const noHeightValue = compHeight === 0 || compHeight === '0' || !compHeight
			return { ...value, height: `var(--content-height, ${noHeightValue ? 'auto' : compHeight})` }
		})
		return res
	}

	return acc
}
